module.exports = __webpack_public_path__ + "static/17-witch-hat-6791834f8450b1fb87d94cc65f218cf0.png";